import { useFocusContext } from '../context/FocusContext';
export const useIsFocused = () => useFocusContext().isFocused;